import Cookies from 'js-cookie'
import CONST from '@/utils/const'

export function getOpenId() {
  return Cookies.get(CONST.USER_KEY)
}

export function setOpenId(openId) {
  return Cookies.set(CONST.USER_KEY, openId)
}

export function removeOpenId() {
  return Cookies.remove(CONST.USER_KEY)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js